<div class="flex-container promo-campaign" *ngIf="campaign">
  <div class="flex-row flex-justify-center">
    <div class="flex-col-6 flex-col-md-6 flex-col-sm-12">
      <div class="image-container spacer">
        <img
          *ngIf="campaign.attributes.image"
          [src]="campaign.attributes.image"
          title="{{ campaign.attributes.name }}"
          alt="{{ campaign.attributes.name }}"
        />
      </div>
      <app-remaining-time-label [start]="campaign.attributes.start_date" [end]="campaign.attributes.end_date"></app-remaining-time-label>
      <div class="spacer">
        <h1>
          {{ 'PROMO.mainOffer' | translate: { amount: highestAmount | translateNumber: language:currency } }}
        </h1>
        <p class="running">{{ campaign.attributes.description }}</p>
      </div>

      <h2>{{ 'PROMO.rewards.label' | translate }}</h2>
      <div class="spacer">
        <div class="promo-banner" *ngFor="let promo of campaign.promotions">
          <div class="promo-icon">
            <img src="/assets/images/icons/gift.svg" />
          </div>
          <div class="info">
            <h3>
              {{
                'PROMO.depositOffer'
                  | translate
                    : {
                        amount: promo.attributes.deposit_target | translateNumber: language:currency,
                        award: promo.attributes.value | translateNumber: language:currency
                      }
              }}
            </h3>
            <div class="caption">
              {{
                'PROMO.depositOfferConditions'
                  | translate
                    : {
                        award: promo.attributes.value / promo.attributes.months_distribution_no | translateNumber: language:currency,
                        month: promo.attributes.months_distribution_no
                      }
              }}
            </div>
          </div>
        </div>
      </div>

      <h2>{{ 'PROMO.howTo.label' | translate }}</h2>
      <div class="spacer">
        <div class="step step-1">
          <div class="promo-icon">
            <img src="/assets/images/icons/pointer.svg" />
          </div>
          <div>
            <h3>{{ 'PROMO.howTo.step1.name' | translate }}</h3>
            <p class="ui-text">{{ 'PROMO.howTo.step1.description' | translate }}</p>
          </div>
        </div>
        <div class="step step-2">
          <div class="promo-icon">
            <img src="/assets/images/icons/arrow-down-square.svg" />
          </div>
          <div>
            <h3>{{ 'PROMO.howTo.step2.name' | translate }}</h3>
            <p class="ui-text" [innerHTML]="'PROMO.howTo.step2.description' | translate: { date: endDate }"></p>
          </div>
        </div>
        <div class="step step-3">
          <div class="promo-icon">
            <img src="/assets/images/icons/gift.svg" />
          </div>
          <div>
            <h3>{{ 'PROMO.howTo.step3.name' | translate }}</h3>
            <p class="ui-text">{{ 'PROMO.howTo.step3.description' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="participation spacer">
        <ng-container *ngIf="!campaign.attributes.opted_in; else alreadyParticipating">
          <button class="ui-button align-center" type="button" (click)="participate(true)">
            {{ 'PROMO.CTA.label' | translate }}
          </button>
        </ng-container>
        <ng-template #alreadyParticipating>
          <h1>{{ 'PROMO.statusParticipating' | translate }}</h1>
        </ng-template>
      </div>

      <div *ngIf="campaign.attributes.tnc_link" class="tnc" target="_blank">
        <a class="ui-text" href="{{ campaign.attributes.tnc_link }}" target="_blank">
          {{ 'PROMO.termsAndConditions' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
